import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("32aba35fe1", "@layer wp-ui{@layer utilities, components, compositions, overrides;@layer components{._19ce0419607e1896__stack{display:flex}}}");
}
export default {"stack":"_19ce0419607e1896__stack"};
